
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GestionConductores.css";
import API from "../api";

export default function GestionConductores() {
  const navigate = useNavigate();

  const [conductores, setConductores] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [conductorEditando, setConductorEditando] = useState(null);
  const [conductorPassword, setConductorPassword] = useState(null);
const [nuevaPassword, setNuevaPassword] = useState("");
const [confirmarPassword, setConfirmarPassword] = useState("");
const [guardandoPassword, setGuardandoPassword] = useState(false);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [formulario, setFormulario] = useState({
    nombres: "",
    apellidos: "",
    telefono: "",
    dpi: "",
    email: "",
    password: "",
    id_vehiculo: ""
  });

  const obtenerToken = () => sessionStorage.getItem("token");

  const cargarDatos = async () => {
    setCargando(true);
    setError("");

    try {
      const token = obtenerToken();

      const [respuestaConductores, respuestaVehiculos] =
        await Promise.all([
          fetch(`${API}/gestion-conductores`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }),
          fetch(`${API}/vehiculos`)
        ]);

      const datosConductores = await respuestaConductores.json();
      const datosVehiculos = await respuestaVehiculos.json();

      if (!respuestaConductores.ok) {
        throw new Error(
          datosConductores.error ||
          "No se pudieron cargar los conductores"
        );
      }

      if (!respuestaVehiculos.ok) {
        throw new Error(
          datosVehiculos.error ||
          "No se pudieron cargar los vehículos"
        );
      }

      setConductores(datosConductores);
      setVehiculos(datosVehiculos);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const actualizarCampo = (e) => {
    const { name, value } = e.target;

    setFormulario((anterior) => ({
      ...anterior,
      [name]: value
    }));
  };

  const registrarConductor = async (e) => {
    e.preventDefault();

    if (guardando) return;

    setGuardando(true);
    setError("");
    setMensaje("");

    try {
const respuesta = await fetch(
  conductorEditando
    ? `${API}/gestion-conductores/${conductorEditando}`
    : `${API}/gestion-conductores`,
  {
    method: conductorEditando ? "PATCH" : "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${obtenerToken()}`
    },
    body: JSON.stringify(
      conductorEditando
        ? {
            nombres: formulario.nombres,
            apellidos: formulario.apellidos,
            telefono: formulario.telefono,
            dpi: formulario.dpi,
            email: formulario.email
          }
        : formulario
    )
  }
);

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo registrar el conductor"
        );
      }

      setMensaje(
  conductorEditando
    ? "Conductor actualizado correctamente"
    : "Conductor registrado correctamente"
);

      setFormulario({
        nombres: "",
        apellidos: "",
        telefono: "",
        dpi: "",
        email: "",
        password: "",
        id_vehiculo: ""
      });
      setConductorEditando(null);

      await cargarDatos();
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  const cambiarVehiculo = async (idConductor, idVehiculo) => {
    if (!idVehiculo) return;

    setError("");
    setMensaje("");

    try {
      const respuesta = await fetch(
        `${API}/gestion-conductores/${idConductor}/vehiculo`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${obtenerToken()}`
          },
          body: JSON.stringify({
            id_vehiculo: Number(idVehiculo)
          })
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo cambiar el camión"
        );
      }

      setMensaje("Camión asignado correctamente");
      await cargarDatos();
    } catch (err) {
      setError(err.message);
    }
  };

  
  // Activar o desactivar la cuenta de un conductor
  const cambiarEstadoUsuario = async (conductor) => {
    const nuevoEstado =
      conductor.estado_usuario === "Activo"
        ? "Inactivo"
        : "Activo";

    const nombreCompleto =
      `${conductor.Nombres} ${conductor.Apellidos}`;

    const confirmar = window.confirm(
      `¿Deseas ${nuevoEstado === "Activo" ? "activar" : "desactivar"} ` +
      `la cuenta de ${nombreCompleto}?`
    );

    if (!confirmar) return;

    setError("");
    setMensaje("");

    try {
      const respuesta = await fetch(
        `${API}/gestion-conductores/${conductor.id_conductor}/estado`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${obtenerToken()}`
          },
          body: JSON.stringify({
            estado: nuevoEstado
          })
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo actualizar la cuenta"
        );
      }

      await cargarDatos();

      setMensaje(
        `La cuenta de ${nombreCompleto} fue ` +
        `${nuevoEstado === "Activo" ? "activada" : "desactivada"} correctamente`
      );
    } catch (err) {
      setError(err.message);
    }
  };

  // Función para editar un conductor
const iniciarEdicion = (conductor) => {
  setError("");
  setMensaje("");

  setConductorEditando(conductor.id_conductor);

  setFormulario({
    nombres: conductor.Nombres || "",
    apellidos: conductor.Apellidos || "",
    telefono: conductor.Telefono || "",
    dpi: conductor.Dpi || conductor.DPI || "",
    email: conductor.email || "",
    password: "",
    id_vehiculo: conductor.id_vehiculo || ""
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

// Abrir formulario para cambiar contraseña
const iniciarCambioPassword = (conductor) => {
  setError("");
  setMensaje("");
  setConductorPassword(conductor);
  setNuevaPassword("");
  setConfirmarPassword("");
};

// Guardar nueva contraseña del conductor
const guardarNuevaPassword = async (e) => {
  e.preventDefault();

  if (!conductorPassword || guardandoPassword) return;

  if (nuevaPassword !== confirmarPassword) {
    setError("Las contraseñas no coinciden");
    return;
  }

  if (
    nuevaPassword.length < 8 ||
    new TextEncoder().encode(nuevaPassword).length > 72
  ) {
    setError(
      "La contraseña debe tener al menos 8 caracteres y no superar 72 bytes"
    );
    return;
  }

  setGuardandoPassword(true);
  setError("");
  setMensaje("");

  try {
    const respuesta = await fetch(
      `${API}/gestion-conductores/${conductorPassword.id_conductor}/password`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${obtenerToken()}`
        },
        body: JSON.stringify({
          nuevaPassword
        })
      }
    );

    const datos = await respuesta.json();

    if (!respuesta.ok) {
      throw new Error(
        datos.error || "No se pudo cambiar la contraseña"
      );
    }

    setConductorPassword(null);
    setNuevaPassword("");
    setConfirmarPassword("");
    setMensaje("Contraseña cambiada correctamente");
  } catch (err) {
    setError(err.message);
  } finally {
    setGuardandoPassword(false);
  }
};

  const vehiculosDisponibles = (idConductor) => {
    return vehiculos.filter((vehiculo) => {
      const asignadoAOtro = conductores.some(
        (conductor) =>
          Number(conductor.id_vehiculo) ===
            Number(vehiculo.id_vehiculo) &&
          Number(conductor.id_conductor) !==
            Number(idConductor)
      );

      return (
        !asignadoAOtro &&
        vehiculo.estado === "Disponible"
      );
    });
  };

  return (
    <div className="gestion-conductores">
      <div className="gestion-encabezado">
        <div>
          <h1>Gestión de conductores</h1>
          <p>
            Administra conductores, cuentas y camiones asignados.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate("/dashboard")}
        >
          Volver al Dashboard
        </button>
      </div>

      {error && (
        <div className="gestion-error">{error}</div>
      )}

      {mensaje && (
        <div className="gestion-exito">{mensaje}</div>
      )}

      <section className="gestion-tarjeta">
        <h2>
  {conductorEditando
    ? "Editar información del conductor"
    : "Registrar nuevo conductor"}
</h2>

        <form
          onSubmit={registrarConductor}
          className="gestion-formulario"
        >
          <input
            name="nombres"
            placeholder="Nombres"
            value={formulario.nombres}
            onChange={actualizarCampo}
            required
          />

          <input
            name="apellidos"
            placeholder="Apellidos"
            value={formulario.apellidos}
            onChange={actualizarCampo}
            required
          />

          <input
            name="telefono"
            placeholder="Teléfono"
            value={formulario.telefono}
            onChange={actualizarCampo}
          />

          <input
            name="dpi"
            placeholder="DPI"
            value={formulario.dpi}
            onChange={actualizarCampo}
          />

       <input
  type="text"
  name="email"
  placeholder="Nombre de usuario"
  value={formulario.email}
  onChange={actualizarCampo}
  autoComplete="username"
  required
/>

          <input
            type="password"
            name="password"
            placeholder="Contraseña (mínimo 8 caracteres)"
            value={formulario.password}
            onChange={actualizarCampo}
            minLength={8}
            autoComplete="new-password"
            required={!conductorEditando}
          />

          <select
            name="id_vehiculo"
            value={formulario.id_vehiculo}
            onChange={actualizarCampo}
          >
            <option value="">Sin camión asignado</option>

            {vehiculosDisponibles(null).map((vehiculo) => (
              <option
                key={vehiculo.id_vehiculo}
                value={vehiculo.id_vehiculo}
              >
                {vehiculo.placa} - {vehiculo.marca}
              </option>
            ))}
          </select>

<button type="submit" disabled={guardando}>
  {guardando
    ? "Guardando..."
    : conductorEditando
    ? "Guardar cambios"
    : "Registrar conductor"}
</button>

{conductorEditando && (
  <button
    type="button"
    onClick={() => {
      setConductorEditando(null);

      setFormulario({
        nombres: "",
        apellidos: "",
        telefono: "",
        dpi: "",
        email: "",
        password: "",
        id_vehiculo: ""
      });

      setError("");
      setMensaje("");
    }}
  >
    Cancelar edición
  </button>
)}

        </form>
      </section>
      {conductorPassword && (
  <section className="gestion-tarjeta">
    <h2>Cambiar contraseña del conductor</h2>

    <p>
      Conductor: {conductorPassword.Nombres}{" "}
      {conductorPassword.Apellidos}
    </p>

    <form
      onSubmit={guardarNuevaPassword}
      className="gestion-formulario"
    >
      <input
        type="password"
        placeholder="Nueva contraseña (mínimo 8 caracteres)"
        value={nuevaPassword}
        onChange={(e) => setNuevaPassword(e.target.value)}
        autoComplete="new-password"
        minLength={8}
        required
      />

      <input
        type="password"
        placeholder="Confirmar nueva contraseña"
        value={confirmarPassword}
        onChange={(e) => setConfirmarPassword(e.target.value)}
        autoComplete="new-password"
        minLength={8}
        required
      />

      <button type="submit" disabled={guardandoPassword}>
        {guardandoPassword
          ? "Guardando..."
          : "Guardar nueva contraseña"}
      </button>

      <button
        type="button"
        disabled={guardandoPassword}
        onClick={() => {
          setConductorPassword(null);
          setNuevaPassword("");
          setConfirmarPassword("");
          setError("");
        }}
      >
        Cancelar
      </button>
    </form>
  </section>
)}

      <section className="gestion-tarjeta">
        <h2>Conductores registrados</h2>

        {cargando ? (
          <p>Cargando conductores...</p>
        ) : (
          <div className="gestion-tabla-contenedor">
            <table className="gestion-tabla">
              <thead>
                <tr>
                  <th>Conductor</th>
                  <th>Correo</th>
                  <th>Teléfono</th>
                  <th>Camión asignado</th>
                  <th>Estado</th>
                  <th>Cambiar camión</th>
                  <th>Acciones</th>
                </tr>
              </thead>

              <tbody>
                {conductores.map((conductor) => (
                  <tr key={conductor.id_conductor}>
                    <td>
                      {conductor.Nombres}{" "}
                      {conductor.Apellidos}
                    </td>

                    <td>{conductor.email || "Sin cuenta"}</td>

                    <td>{conductor.Telefono || "-"}</td>

                    <td>
                      {conductor.placa
                        ? `${conductor.placa} - ${conductor.marca}`
                        : "Sin asignar"}
                    </td>

                    <td>
                      {conductor.estado_usuario || "Sin cuenta"}
                    </td>

                    <td>
                      <select
                        value={conductor.id_vehiculo || ""}
                        onChange={(e) =>
                          cambiarVehiculo(
                            conductor.id_conductor,
                            e.target.value
                          )
                        }
                      >
                        <option value="">
                          Seleccionar camión
                        </option>

                        {conductor.id_vehiculo &&
                          !vehiculosDisponibles(
                            conductor.id_conductor
                          ).some(
                            (v) =>
                              Number(v.id_vehiculo) ===
                              Number(conductor.id_vehiculo)
                          ) && (
                            <option
                              value={conductor.id_vehiculo}
                            >
                              {conductor.placa} - {conductor.marca}
                            </option>
                          )}

                        {vehiculosDisponibles(
                          conductor.id_conductor
                        ).map((vehiculo) => (
                          <option
                            key={vehiculo.id_vehiculo}
                            value={vehiculo.id_vehiculo}
                          >
                            {vehiculo.placa} - {vehiculo.marca}
                          </option>
                        ))}
                     
</select>
</td>

{/* Nueva columna para activar o desactivar usuarios */}
<td>
<button
  type="button"
  className="gestion-btn-editar"
  onClick={() => iniciarEdicion(conductor)}
>
  Editar
</button>

<button
  type="button"
  className="gestion-btn-password"
  onClick={() => iniciarCambioPassword(conductor)}
>
  Cambiar contraseña
</button>

  {conductor.estado_usuario === "Activo" ||
  conductor.estado_usuario === "Inactivo" ? (
    <button
      type="button"
      className={
        conductor.estado_usuario === "Activo"
          ? "gestion-btn-desactivar"
          : "gestion-btn-activar"
      }
      onClick={() => cambiarEstadoUsuario(conductor)}
    >
      {conductor.estado_usuario === "Activo"
        ? "Desactivar"
        : "Activar"}
    </button>
  ) : (
    <span>Sin cuenta vinculada</span>
  )}
</td>
</tr>

                ))}

                {conductores.length === 0 && (
                  <tr>
                    <td colSpan="7">
                      No hay conductores registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
